import { render, staticRenderFns } from "./DeviceStatusTiles.vue?vue&type=template&id=bfe2b6bc"
import script from "./DeviceStatusTiles.vue?vue&type=script&lang=js"
export * from "./DeviceStatusTiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports